export const API = {
  // 用户相关接口
  USER: {
    Login: '/admin/login',
    Logout: '/admin/logout',  // 修改为正确的退出接口路径
    INFO: '/user/info',
    PROFILE: '/user/profile'
  },

  // 系统相关接口
  SYSTEM: {
    MENU: '/system/menu',
    ROLE: '/system/role',
    PERMISSION: '/system/permission'
  },

  // 报告相关接口
  REPORT: {
    LIST: '/admin/getreportlist', // 获取案件列表
    DETAIL: '/api/claim/query', // 查询案件详情 使用user查询
    CHANGE: '/admin/report/change', // 修改案件接口
    CHECKDOWNLOAD: '/admin/report/checkdownload', // 检测下载权限
    DOWNLOAD: '/admin/report/download', // 下载案件接口
    DELETE: '/admin/report/delete', // 删除案件接口
    EXPORT: '/api/export', // 导出接口
  },
  ACCOUNT: {
    ADD: '/admin/account/add', // 添加账号
    DELETE: '/admin/account/delete', // 删除账号
    UPDATE: '/admin/account/update', // 更新账号
    LIST: '/admin/account/list', // 获取账号列表
  },
  LOGS: {
    LIST: '/admin/logs/list', // 获取日志列表
  },
  FILE: {
    INFO: 'admin/disk/info' , // 获取磁盘信息
    UPLOAD: 'admin/disk/strategy' , // 更改为策略配置接口
  }
  // 其他模块接口...可以继续添加
}

export default API
